import apiUrl from "../../../../utils/settings";

export const invoicePaginatedUrl = () => {
  return apiUrl + '/user-invoices/paginated';
};
export const invoiceDetailsUrl = () => {
    return apiUrl + '/user-invoices/detail';
    };

export const invoiceFileDownloadUrl = () => {
  return apiUrl + '/invoices/get-invoice-file';
};